import { RefreshCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { PurchaseOrderProductsSyncInformationsDialog } from './purchase-order-products-sync-informations-dialog';
import type { PurchaseOrderProductsSyncInformationsProps } from './types/purchase-order-products-sync-informations.types';

export function PurchaseOrderProductsSyncInformationsButton({
  isSyncEnabled,
  data,
}: PurchaseOrderProductsSyncInformationsProps) {
  const { t } = useTranslation('purchaseOrder');
  const { counts, dialog } = data;

  const buttonLabel = counts.hasSelectedProducts
    ? t('syncInformationsSelectedBtn', {
        count: counts.selectedProductsCount,
      })
    : t('syncInformationsAllBtn', { count: counts.totalProductsCount });

  return (
    <>
      <Button
        disabled={!isSyncEnabled}
        onClick={dialog.onOpen}
        type='button'
        variant='outline'
      >
        {buttonLabel}
        <RefreshCcw aria-hidden className='size-4' />
      </Button>

      <PurchaseOrderProductsSyncInformationsDialog data={data} />
    </>
  );
}
